import { useMutation } from '@tanstack/react-query';

import { paymentProviderTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig } from '@/libraries/react-query';

const validatePaymentProviderKey: paymentProviderTypes.ValidatePaymentProviderKey = (
  data
): Promise<{ exists: boolean }> => {
  return axios.post(`/payment-providers/keys/validate`, data);
};

type ValidatePaymentProviderOptions = {
  config?: MutationConfig<typeof validatePaymentProviderKey>;
};

export function useValidatePaymentProviderKey({
  config = {},
}: ValidatePaymentProviderOptions = {}) {
  return useMutation({
    ...config,
    mutationFn: validatePaymentProviderKey,
  });
}
